import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { apiPost } from '../../utils/apiClient';
import { setCoinsLeft } from '../../store/uiSlice';
import { addReportToServer } from '../../functions/sendReport';
import './WelcomePage.css';

const TITLE =
  'We are thrilled to welcome you to our Virtual Carnival dedicated to the celebration of Inclusion!';
const CONTENT1 =
  "We believe that fostering a culture of inclusion is not just a value; it's a commitment. Inclusion makes us stronger, more creative, and better equipped to overcome challenges. Today, we come together to celebrate our diversity and recognize the beauty that lies in our differences.";
const CONTENT2 =
  'This virtual carnival is a celebration of US - our cultures, our traditions, and our unique contributions to our community. Engage in the stalls with open hearts and minds, ready to learn, share, and inspire inclusion in our everyday life.';

export default function WelcomePage() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector((s) => s.auth.user);
  const [slideIn, setSlideIn] = useState(false);

  useEffect(() => {
    if (!user?.userId) return;
    (async () => {
      try {
        const res = await apiPost('/ensureUser', {
          userId: user.userId,
          name: user.name,
          email: user.email,
          userType: user.roles || user.role || '',
        });
        dispatch(setCoinsLeft(res.coins_left ?? 0));
        if (res.created) {
          await addReportToServer(user, {
            points: 0,
            reportTime: '00:00:00',
            answers: ['inclusion_start'],
          });
        }
      } catch (err) {
        console.error('ensureUser failed', err);
      }
    })();
  }, [user, dispatch]);

  useEffect(() => {
    const t = setTimeout(() => setSlideIn(true), 500);
    return () => clearTimeout(t);
  }, []);

  return (
    <div
      className="welcome-page intro-bg"
      style={{
        '--ic-bg': 'url(/img/BG_2.jpg)',
        '--ic-bg-mob': 'url(/img/introbgmob.png)',
        '--ic-art': 'url(/img/intro.jpg)',
        '--ic-art-mob': 'url(/img/introbgmob.png)',
      }}
    >
      <div className="intro-background" aria-hidden="true" />
      <div className={`intro-alldata ${slideIn ? 'intro-slide-in' : ''}`}>
        <h4 className="intro-title">{TITLE}</h4>
        <div className={`intro-content ${slideIn ? 'show' : ''}`} id="content1">
          <h4>{CONTENT1}</h4>
        </div>
        <div className={`intro-content intro-content2 ${slideIn ? 'show' : ''}`} id="content2">
          <h4>{CONTENT2}</h4>
        </div>
        <button type="button" className="intro-next" onClick={() => navigate('/hub')}>
          Next
        </button>
      </div>
      <div className="intro-peoples">
        <img src="/img/peoples.png" alt="" />
      </div>
    </div>
  );
}
